/**
 * Sanitizes a component name to create a stable panel ID segment
 */
export function sanitizeComponentName(name: string): string {
  return name.trim().toLowerCase().replace(/\s+/g, "-")
}

/**
 * Generates a stable panel ID from a component name and occurrence index
 */
export function generatePanelId(componentName: string, occurrenceIndex: number): string {
  const sanitized = sanitizeComponentName(componentName)
  return `op-layout-engine-${sanitized}-${occurrenceIndex}`
}

/**
 * Gets the component name for a dashboard module
 */
export function getModuleComponentName(moduleType: string, moduleId: string): string {
  return `${moduleType}-${moduleId}`
}
